import { dev } from '$app/environment';

interface CaptureEventData {
	category: 'app' | 'landing_page';
	target: string;
	verb: 'initialize' | 'click';
	data?: Record<string, unknown> | undefined;
}

interface AnalyticsClient {
	capture(data: CaptureEventData): void;
}

class MockAnalyticsClient implements AnalyticsClient {
	capture(data: CaptureEventData) {
		if (dev) {
			console.debug('analytics event capture', data || {});
		}
	}
}

class AnalyticsClientWrapper implements AnalyticsClient {
	constructor(private client: AnalyticsClient) {}

	setClient(newClient: AnalyticsClient) {
		this.client = newClient;
	}

	capture(data: CaptureEventData) {
		this.client.capture(data);
	}
}

export const analytics = new AnalyticsClientWrapper(new MockAnalyticsClient());
